import {Injectable} from '@angular/core';

// import {AngularIndexedDB} from 'angular2-indexeddb';
// import {AngularIndexedDB} from '../classes/angular2-indexeddb';

import {MyIndexedDbService} from './myindexeddb.service';


import {AuthService} from './auth.service';
import {LogService} from './log.service';

// import * as pako from 'pako';


@Injectable()
export class CacheStorageService {
	constructor(
		private authService: AuthService,
		private log: LogService,
		private myIndexedDbService: MyIndexedDbService
	) {}


	db: any = null;

	keys = {
		authJwt: 'authJwt',

		allFilms: 'allFilms',
		allUsers: 'allUsers',

		allFilter: 'allFilter',
		availableFilter: 'availableFilter',
		lineupFilter: 'lineupFilter',
		reviewedFilter: 'reviewedFilter',

		ballotFilter: 'ballotFilter',
		blockFilter: 'blockFilter',
		gridFilter: 'gridFilter',
		letterFilter: 'letterFilter',

		autoLogin: 'autoLogin',
		checkVersion: 'checkVersion',
		savedInfo: 'savedInfo',
		visibleTabs: 'visibleTabs',

		enableBallotReport: 'enableBallotReport'
	};
	keyNames = {
		authJwt: 'auth-jwt',

		allFilms: 'all-films',
		allUsers: 'all-users',

		allFilter: 'all-filter',
		availableFilter: 'available-filter',
		lineupFilter: 'lineup-filter',
		reviewedFilter: 'reviewed-filter',
		letterFilter: 'letter-filter',

		ballotFilter: 'ballot-filter',
		blockFilter: 'block-filter',
		gridFilter: 'grid-filter',

		autoLogin: 'auto-login',
		checkVersion: 'check-version',
		savedInfo: 'saved-info',
		visibleTabs: 'visible-tabs',

		enableBallotReport: 'enable-ballot-report'
	};
// localStorage.removeItem('user-profile');
// localStorage.removeItem('user-profile-queue');
// localStorage.removeItem('all-users');
// localStorage.removeItem('all-films');
// localStorage.removeItem('all-reviews');
// localStorage.removeItem('user-reviews');
// localStorage.removeItem('user-reviews-queue');
// localStorage.removeItem('user-films');


	public campaignUserIds = [];


	getStatsString() {
		// return '' + (this.getStorageUsed() / (1024 * 1024)).toFixed(3) + ' MB used, ' +  (this.getStorageRemaining() / (1024 * 1024)).toFixed(3) + ' MB remaining';
		return '' + (this.getStorageUsed() / (1024 * 1024)).toFixed(3) + ' MB used';
	}


	getStorageUsed() {
		try {
			return JSON.stringify(localStorage).length * 2;
		} catch (ex) {
			this.log.error('Exception while getting size of localStorage.');
			this.log.error(ex);
			return 0;
		}
	}


	getStorageRemaining() {
		let remaining = this.getStorageMax() - this.getStorageUsed();
		if (remaining > 0) {
			return remaining;
		} else {
			return 0;
		}
	}


	// I think actually there is a max on individual string size, separate from the max total size
	// says 5 MB is max, https://www.html5rocks.com/en/tutorials/offline/quota-research/
	// to test https://arty.name/localstorage.html
	getStorageMax() {
		return 1024 * 1024 * 5;
	}


	read(key: string) {
		let start = Date.now();

		if (!key) {
			this.log.error('Invalid key.');
			return null;
		}
		console.log('read, key = ' + key);
		try {
			if (localStorage) {
				if (this.keyNames[key]) {
					// no compression
					let valueString = localStorage.getItem(this.keyNames[key]);
					if (!valueString) {
						return {};
					}
					let value = JSON.parse(valueString);
					if (!value) {
						return {};
					}

					let end = Date.now();
					console.log('    ...   ' + (end - start) + 'msec to read key, CacheStorageService');




/*
					// with compression
					let valueBase64Compressed = localStorage.getItem(this.keyNames[key]);
					if (!valueBase64Compressed) {
						return {};
					}
					let valueCompressed = atob(valueBase64Compressed);
					if (!valueCompressed) {
						return {};
					}
					let valueString: any = pako.inflate(valueCompressed, {to: 'string'});
					if (!valueString) {
						return {};
					}
					let value = JSON.parse(valueString);
					if (!value) {
						return {};
					}



					let end = Date.now();
					console.log('    ...   ' + (end - start) + 'msec to read key, CacheStorageService');
*/


					return value;
				} else {
					this.log.error('Could not find key to read.  key = ' + key);
				}
			} else {
				this.log.error('No local storage support');
			}
			return {};
		} catch (ex) {
			this.log.error('Exception while reading key.  key = ' + key);
			this.log.error(ex);
			return {};
		}
	}


	write(key: string, value: any) {
		let start = Date.now();


		if (!key) {
			this.log.error('Invalid key.');
			return;
		}
		if (!value) {
			this.log.error('Invalid value.');
			return;
		}
		console.log('write, key = ' + key);
		try {
			if (localStorage) {
				if (this.keyNames[key]) {
					// no compression
					let valueString = JSON.stringify(value);


					// let stringify = Date.now();
					// console.log('    ...    ' + (stringify - start) + 'msec to stringify key, CacheStorageService');


					localStorage.setItem(this.keyNames[key], valueString);

					let end = Date.now();
					console.log('    ...   ' + (end - start) + 'msec to write key, CacheStorageService');



					// let save = Date.now();
					// console.log('    ...    ' + (save - stringify) + 'msec to save key, CacheStorageService');







/*
					// with compression
					let valueString = JSON.stringify(value);


					let stringify = Date.now();
					console.log('    ...    ' + (stringify - start) + 'msec to stringify key, CacheStorageService');


					let valueCompressed = pako.deflate(valueString, {to: 'string'});


					let compress = Date.now();
					console.log('    ...    ' + (compress - stringify) + 'msec to compress key, CacheStorageService');


					let valueBase64Compressed = btoa(valueCompressed);


					let base64 = Date.now();
					console.log('    ...    ' + (base64 - compress) + 'msec to base64 key, CacheStorageService');


					localStorage.setItem(this.keyNames[key], valueBase64Compressed);


					let save = Date.now();
					console.log('    ...    ' + (save - base64) + 'msec to save key, CacheStorageService');
*/

				} else {
					this.log.error('Could not find key to write.  key = ' + key);
				}
			} else {
				this.log.error('No local storage support.');
			}
		} catch (ex) {
			this.log.error('Exception while writing key.  key = ' + key + ', value = ' + value);
			this.log.error(ex);
		}
	}


	clearAll() {
		if (localStorage) {
			Object.keys(this.keyNames).forEach((key) => {
				let keyName = this.keyNames[key];
				localStorage.removeItem(keyName);
			});
		} else {
			this.log.error('No local storage support.');
		}

		if (window.indexedDB) {
			console.log('clearing indexed db');

			let DBDeleteRequest = window.indexedDB.deleteDatabase('oceanbluffproductions');
			DBDeleteRequest.onerror = function(event: any) {
				console.log('Error deleting database.');
				console.log(event);
			};
			DBDeleteRequest.onsuccess = function(event: any) {
				console.log('Database deleted successfully');

				console.log(event.result); // should be undefined
				console.log(event);
			};
		} else {
			this.log.error('No indexed db support.');
		}
	}


	clearAllExceptAuth() {
		return new Promise( async (resolve, reject) => {

			if (localStorage) {
				Object.keys(this.keyNames).forEach((key) => {
					let keyName = this.keyNames[key];
					if (keyName !== 'auth-jwt') {
						localStorage.removeItem(keyName);
					}
				});
			} else {
				this.log.error('No local storage support.');
			}

			if (window.indexedDB) {
				console.log('clearing indexed db');
				let needsResolve = true;

				if (this.db) {
					this.db.close();
				}

				let DBDeleteRequest = window.indexedDB.deleteDatabase('oceanbluffproductions');

				// IDBOpenDBRequest
				let that = this;
				DBDeleteRequest.onblocked = function() {
					that.log.error('onblocked, Your database version can\'t be upgraded because the app is open somewhere else.');
					needsResolve = false;
					return resolve();
				};
				DBDeleteRequest.onupgradeneeded = function(event) {
					that.log.error('onupgradeneeded, Should not be called.');
					that.log.info(event);
					needsResolve = false;
					return resolve();
				};


				// IDBRequest
				DBDeleteRequest.onerror = function(event: any) {
					that.log.error('onerror, Error deleting database.');
					// that.log.error(event);
					needsResolve = false;
					return resolve();
				};
				DBDeleteRequest.onsuccess = function(event: any) {
					console.log('onsuccess, Database deleted successfully');
					// console.log(event.result); // should be undefined
					// console.log(event);
					needsResolve = false;
					return resolve();
				};

				console.log('waiting for deleted database');
				setTimeout(() => {
					if (needsResolve) {
						that.log.error('clearAllExceptAuth, indexedDB.deleteDatabase, needsResolve was true');
						return resolve();
					}
				}, 500);

			} else {
				this.log.error('No indexed db support.');
				return resolve();
			}


		});
	}


	ensureIndexedDb(): any {
		// in Chrome devtools console
		// indexedDB.deleteDatabase("oceanbluffproductions")
		// then do page refresh
		const schemaVersion = 2;

		return new Promise( (resolve, reject) => {
			if (this.db) {
				console.log('-----> db already setup');
				return resolve();
			}
			if (!window.indexedDB) {
				console.log('No indexed db support.');
				return resolve();
			}

			let start = Date.now();

			console.log('-----> creating AngularIndexedDB');
			// this.db = new AngularIndexedDB('oceanbluffproductions', schemaVersion);
			this.db = this.myIndexedDbService.createDb('oceanbluffproductions', schemaVersion);
			// console.log('this.db');
			// console.log(this.db);

			console.log('-----> creating store');
			this.db.createStore(schemaVersion, (evt) => {
				console.log('-----> creating store returning, onupgradeneeded');

				// let objectStore = evt.currentTarget.result.createObjectStore('films', { keyPath: 'filmId'});
				// objectStore.createIndex('filmId', 'filmId', { unique: false });

				let theDb = evt.target.result;

				if (theDb) {
					console.log('theDb.objectStoreNames 1');
					console.log(theDb.objectStoreNames);

					let existingNames = [];
					if (theDb.objectStoreNames) {
						if (Array.isArray(theDb.objectStoreNames)) {
							console.log('--- found an array!!');
							existingNames = theDb.objectStoreNames;
						} else {
							console.log('--- found an object!!');
							Object.keys(theDb.objectStoreNames).forEach((objectStoreName) => {
								existingNames.push(theDb.objectStoreNames[objectStoreName]);
							});
						}
					}
					console.log('existingNames');
					console.log(existingNames);

					if (existingNames.indexOf(this.keyNames.allFilms) === -1 ) {
						let objectStore1 = evt.currentTarget.result.createObjectStore(this.keyNames.allFilms);
					}
					if (existingNames.indexOf(this.keyNames.allUsers) === -1 ) {
						let objectStore2 = evt.currentTarget.result.createObjectStore(this.keyNames.allUsers);
					}
				}

				// let objectStore1 = evt.currentTarget.result.createObjectStore(this.keyNames.allFilms);
				// let objectStore2 = evt.currentTarget.result.createObjectStore(this.keyNames.allUsers);

				// if (theDb) {
				// 	console.log('theDb.objectStoreNames 2');
				// 	console.log(theDb.objectStoreNames);
				// 	console.log(typeof theDb.objectStoreNames);
				// }


				console.log('ensureIndexedDb, onupgradeneeded, elasped = ' + (Date.now() - start) );
			})
			.then(() => {
				// let theOther = this;
				// setTimeout(() => {
				// 	if (theOther && theOther.db && theOther.db.getDb()) {
				// 		console.log('theOther.db.getDb().objectStoreNames');
				// 		console.log(theOther.db.getDb().objectStoreNames);
				// 	} else {
				// 		console.log('things are null');
				// 	}
				// }, 3000);
				console.log('ensureIndexedDb, then, elasped = ' + (Date.now() - start) );
				resolve();
			})
			.catch((err) => {
				this.log.error('IndexedDb error creating store:');
				this.log.error(err);
			});
		});
	}





	readIndexedDb(key: string): any {
		return new Promise((resolve, reject) => {
			let start = Date.now();

			if (!key) {
				this.log.error('Invalid key.');
				return resolve();
			}
			if (!this.keyNames[key]) {
				this.log.error('Invalid key name.');
				return resolve();
			}

			console.log('read, key = ' + key);
			console.log('read, keyName = ' + this.keyNames[key]);
			try {
				this.ensureIndexedDb()
				.then(() => {
					if (!this.db) {
						return resolve();
					}



					this.db.getByKey(this.keyNames[key], this.keyNames[key]).then((allFilms) => {
						// console.log('-----> readIndexedDb, getByKey success');
						// console.log(allFilms);

						console.log('readIndexedDb, add, elasped = ' + (Date.now() - start) );
						return resolve(allFilms);

					}, (error) => {
						console.log('-----> readIndexedDb, getByKey error');
						console.log(error);
						return resolve();
					});



				})
				.catch((err) => {
					this.log.error(err);
					return resolve();
				});

/*
				if (localStorage) {
					if (this.keyNames[key]) {
						// no compression
						let valueString = localStorage.getItem(this.keyNames[key]);
						if (!valueString) {
							return {};
						}
						let value = JSON.parse(valueString);
						if (!value) {
							return {};
						}

						let end = Date.now();
						console.log('    ...   ' + (end - start) + 'msec to read key, CacheStorageService');

						return value;
					} else {
						this.log.error('Could not find key to read.  key = ' + key);
					}
				} else {
					this.log.error('No local storage support');
				}
				return {};
*/
			} catch (ex) {
				this.log.error('Exception while reading key.  key = ' + key);
				this.log.error(ex);
				return {};
			}
		});
	}


	writeIndexedDb(key: string, value: any): any {
		return new Promise((resolve, reject) => {
			let start = Date.now();

			if (!key) {
				this.log.error('Invalid key.');
				return resolve();
			}
			if (!this.keyNames[key]) {
				this.log.error('Invalid key name.');
				return resolve();
			}
			if (!value) {
				this.log.error('Invalid value.');
				return resolve();
			}
			console.log('write, key = ' + key);
			console.log('write, keyName = ' + this.keyNames[key]);
			try {
				this.ensureIndexedDb()
				.then(() => {
					if (!this.db) {
						return resolve();
					}

					console.log('value');
					console.log(value);

					// first, remove the item
					// note ok if error because item was not there while removing
					this.db.delete(this.keyNames[key], this.keyNames[key]).then(() => {
						console.log('-----> writeIndexedDb, remove success');

						// now add
						this.db.add(this.keyNames[key], value, this.keyNames[key]).then(() => {
							console.log('-----> writeIndexedDb, add success');
							console.log('writeIndexedDb, add, elasped = ' + (Date.now() - start) );
							return resolve();
						}, (err) => {
							console.log('-----> writeIndexedDb, add error');
							console.log(err);
							return resolve();
						});
					}, (err2) => {
						console.log(err2);
						console.log('-----> writeIndexedDb, remove error');

						// now add
						this.db.add(this.keyNames[key], value, this.keyNames[key]).then(() => {
							console.log('-----> writeIndexedDb, add success');
							console.log('writeIndexedDb, add, elasped = ' + (Date.now() - start) );
							return resolve();
						}, (err) => {
							console.log('-----> writeIndexedDb, add error');
							console.log(err);
							return resolve();
						});
					});
				})
				.catch((err) => {
					this.log.error(err);
					return resolve();
				});

/*
				if (localStorage) {
					if (this.keyNames[key]) {
						let valueString = JSON.stringify(value);

						localStorage.setItem(this.keyNames[key], valueString);

						let end = Date.now();
						console.log('    ...   ' + (end - start) + 'msec to write key, CacheStorageService');

					} else {
						this.log.error('Could not find key to write.  key = ' + key);
						return resolve();
					}
				} else {
					this.log.error('No local storage support.');
					return resolve();
				}
*/

			} catch (ex) {
				this.log.error('Exception while writing key.  key = ' + key + ', value = ' + value);
				this.log.error(ex);
				return resolve();
			}
		});
	}


	readCampaign() {
		try {
			if (localStorage) {
				let valueString = localStorage.getItem('campaignIds');
				if (!valueString) {
					return;
				}
				let value = JSON.parse(valueString);
				if (!value) {
					return;
				}
				this.campaignUserIds = value;
			}
		} catch (ex) {
			this.log.error('Exception while reading key.  key = campaignIds');
			this.log.error(ex);
			return;
		}
	}


	writeCampaign() {
		try {
			if (localStorage) {
				let valueString = JSON.stringify(this.campaignUserIds);
				localStorage.setItem('campaignIds', valueString);
			}
		} catch (ex) {
			this.log.error('Exception while reading key.  key = campaignIds');
			this.log.error(ex);
			return;
		}
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/cache-storage.service.ts